import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from 'react';
import { Icon } from 'semantic-ui-react';
import './IconElement.css';
var horizontalAlignment = {
  display: 'inline-flex',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'center'
};
var verticalAlignment = {
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  display: 'inline-flex',
  flexDirection: 'column'
};

var IconElement = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(IconElement, _React$PureComponent);

  function IconElement() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = IconElement.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        iconType = _this$props.iconType,
        iconSize = _this$props.iconSize,
        iconPosition = _this$props.iconPosition,
        element = _this$props.element,
        className = _this$props.className,
        onClick = _this$props.onClick;
    var horizontal = iconPosition === 'left' || iconPosition === 'right';
    var elementFirst = iconPosition === 'right' || iconPosition === 'bottom';
    return /*#__PURE__*/React.createElement("div", {
      onClick: onClick,
      className: "ie-base-class " + (horizontal && 'ie-horiz') + " " + className,
      style: horizontal ? horizontalAlignment : verticalAlignment,
      role: "button",
      onKeyDown: onClick,
      tabIndex: -1
    }, elementFirst && element, /*#__PURE__*/React.createElement(Icon, {
      name: iconType,
      size: iconSize
    }), !elementFirst && element);
  };

  return IconElement;
}(React.PureComponent);

export { IconElement as default };
IconElement.defaultProps = {
  className: '',
  element: /*#__PURE__*/React.createElement("h2", null, "Sample Element"),
  iconPosition: 'left',
  iconSize: 'large',
  iconType: 'phone',
  onClick: null
};